import type {ReactElement} from 'react';
import React from 'react';
import type { FontSelectorPanelProps} from '@Components/font-selector-panel';
import {FontSelectorPanel} from '@Components/font-selector-panel';
import type {BrandFont} from '@Components/editor-brands/editor-brands.types';
import type {FontData} from '@Libraries/font-library';

export function PosterEditingBaseFontSelector({
  isSelectedFontLoading = false,
  className = '',
  onBrandItemClicked = (): void => {},
  onBackButtonCallback = (): void => {},
  onCloseButtonCallback = (): void => {},
  onSelectFontFamily = (): void => {},
  onDeleteFontItem = (): void => {},
  onFileUploaded = (): void => {},
  onAddBrandAsset = (): void => {},
  showDropdownVariant = false,
  showHeader = false,
  selectedFontFamily = '',
  scriptForRecommendedFonts = '',
  hasSmallTopPadding = false,
  ...props
}: FontSelectorPanelProps): ReactElement<any> {
  return (
    <FontSelectorPanel
      className={className}
      onFileUploaded={(uploadedFontFamily, uploadedFont): void => {
        if (onFileUploaded) {
          onFileUploaded(uploadedFontFamily);
        }
        if (uploadedFont) {
          onSelectFontFamily(uploadedFont);
        }
      }}
      showDropdownVariant={showDropdownVariant}
      fontsInDesign={window.posterEditor?.whiteboard?.getFontsOnPoster() ?? []}
      onBrandItemClicked={(brand: BrandFont): void => {
        onBrandItemClicked(brand);
      }}
      isSelectedFontLoading={isSelectedFontLoading}
      selectedFontFamily={selectedFontFamily}
      onSelectFontFamily={(font: FontData): void => {
        onSelectFontFamily(font);
      }}
      showHeader={showHeader}
      onBackButtonCallback={(): void => {
        onBackButtonCallback();
      }}
      onDeleteFontItem={onDeleteFontItem}
      onAddBrandAsset={(): void => {
        onAddBrandAsset();
      }}
      scriptForRecommendedFonts={scriptForRecommendedFonts}
      showSmallDropdownForBrands={false}
      showBackButton={props.showBackButton}
      showCloseButton={props.showCloseButton}
      onCloseButtonCallback={(): void => {
        onCloseButtonCallback();
      }}
      headerText={props.headerText}
      hasSmallTopPadding={hasSmallTopPadding}
    />
  );
}
